import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 0,
      name: i18n.t('imports.statuses.pendiente')
    },
    {
      id: 1,
      name: i18n.t('imports.statuses.ok')
    },
    {
      id: 2,
      name: i18n.t('imports.statuses.ko')
    },
    {
      id: 3,
      name: i18n.t('imports.statuses.revisado')
    }
  ]
}

export function TIPOS_IMPORTACION_ESTADO (state) {
  return configHelper.getConfig(state, 'TIPOS_IMPORTACION_ESTADO', GenerateConfig)
}

